export default (theme) => ({
  cardTableContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  gutterTop: {
    marginTop: theme.spacing(3),
  },
});
